import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customNumberFormatter'
})
export class CustomNumberFormatterPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return value.length > 6
      ? `${value.substr(0, value.length - 6)}M`
      : ( value.length > 3 ? `${value.substr(0, value.length - 3)}k` : value);
  }
}
